import store from '@/store/index';
import * as request from '@/request/common';
import router from '@/router';
// 会议权限
import routerViewMeeting from './meeting.config.js';
// 论坛权限
import routerViewForum from './forum.config.js';
// 论坛id父级格式化路由时使用
import { forum_id } from '@/config/index.js';
// 路由管理
let routeData = {
    path: '/route/:lang/:meeting_id',
    name: 'RouteView',
    meta: {
        title: '路由管理'
    },
    component: () => import(/* webpackChunkName: "RouterView" */ '../views/route-config/route.vue')
};
// 布局视图
const getRouterLayout = forumID => {
    let meetingData = {
        path: '/:lang/:meeting_id',
        redirect: '/index/:lang/:meeting_id'
    };
    let forumData = {
        path: '/:lang/:meeting_id/:forum_id',
        redirect: '/forum-index/:lang/:meeting_id/:forum_id'
    };
    let commonData = {
        name: 'AdminLayout',
        meta: {
            title: '首页'
        },
        component: () => import(/* webpackChunkName: "Layout" */ '../layout/index.vue'),
        children: []
    };

    let layoutData = meetingData;
    if (forumID) {
        layoutData = forumData;
    }
    // 合并
    return Object.assign(commonData, layoutData);
};

// 格式化左侧菜单数据
const listToTree = (list, tree, parent_id, level, lang) => {
    list.forEach(item => {
        item.module_name = lang == 'cn' ? item.module_name : item.module_name_en;
        // 如果不在菜单中隐藏则加入菜单列表
        if (!item?.meta?.hide_menu) {
            // 判断是否为父级菜单
            if (item.parent_id == parent_id) {
                const child = {
                    ...item,
                    list: []
                };
                // 增加路由层级level ( 父id等于0或者层级等于论坛id 则相当于第一轮循环 level中需要加入当前id )
                child['level'] = !parent_id || level == forum_id ? item.id : level + '_' + item.id;

                // 迭代 list， 找到当前菜单相符合的所有子菜单
                listToTree(list, child.list, item.id, child.level, lang);
                // 加入到树中
                tree.push(child);
            }
        }
    });
};

// 动态设置路由
export default headers => {
    headers['mid'] = headers['meetingID'];
    return new Promise((resolve, reject) => {
        request.get({ url: 'getMenu', headers }).then(res => {
            let asidebarList = []; // 左侧菜单

            // 路由权限添加
            if (res.data.length > 0) {
                // 获取布局JSON
                let layoutRoute = getRouterLayout(headers.forumID);
                router.addRoute(layoutRoute);

                // 默认添加首页
                let roleList = [
                    {
                        id: -1,
                        module_url: 'Index',
                        module_name: '首页',
                        module_name_en: 'Home',
                        parent_id: headers.forumID ? forum_id : 0,
                        module_marking: 'med-shouye'
                    }
                ];

                // 会议权限
                let routerViewList = routerViewMeeting();
                // 如有有forumID则为论坛权限
                if (headers.forumID) {
                    routerViewList = routerViewForum();
                }

                roleList = roleList.concat(res.data);

                roleList.forEach(it => {
                    let currRoute = {};
                    // 存在key值
                    if (it.module_url) {
                        // key值在module.config.js中有对应value
                        if (routerViewList[it.module_url]) {
                            // 路由视图与数据库路由合并
                            currRoute = {
                                ...routerViewList[it.module_url],
                                name: it.module_url,
                                meta: {
                                    icon: it.module_marking,
                                    title: headers.language == 'cn' ? it.module_name : it.module_name_en,
                                    ...routerViewList[it.module_url].meta
                                }
                            };
                            router.addRoute('AdminLayout', currRoute);
                        }
                    }
                    currRoute = {
                        ...currRoute,
                        ...it
                    };
                    // 添加到菜单中
                    asidebarList.push(currRoute);
                });

                // 添加路由管理
                router.addRoute('AdminLayout', routeData);
                resolve();
            } else {
                reject();
            }

            // 默认添加404页面
            router.addRoute({
                path: '/:carchAll(.*)/:lang/:meeting_id',
                name: '/404',
                component: () => import('@/views/404')
            });

            // 格式化导航数据
            const navList = [];
            // 后端数据, 根级树数组,  根级 PID, 层级Level
            let p_id = headers.forumID ? forum_id : 0;
            listToTree(asidebarList, navList, p_id, p_id, headers.language);
            console.log(navList);
            store.commit('updateState', { 'asidebar.navList': navList });
        });
    });
};
